export default __webpack_public_path__ + "static/media/reactrainbow.3610ac2e.webp";